import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import Global from '../../../../../store/global-selectors';

import { messages } from '../messages';

export const ServiceClassification = ({ selectedServiceClassificationId, onChange }) => {
  const intl = useIntl();
  const sellerServiceClassifications = useSelector(Global.selectReferenceDatagetServiceClassifications);

  const serviceClassifications = useMemo(() => {
    const mappedServiceClassifications = sellerServiceClassifications.map((serviceClassification) => ({
      id: serviceClassification.shippingServiceClassId.toString(),
      name: serviceClassification.name,
    }));

    return [
      {
        id: 'show-all',
        name: intl.formatMessage(messages.serviceClassificationShowAll),
      },
      ...mappedServiceClassifications,
    ];
  }, [sellerServiceClassifications, intl]);

  const selectedServiceClassification =
    serviceClassifications.find((serviceClassification) => serviceClassification.id === selectedServiceClassificationId) || {};

  return (
    <DropdownMenu dropdownMenuShouldHaveWidthOfButton fullWidth onChange={onChange} value={selectedServiceClassificationId} variant='form'>
      <DropdownMenuToggler>{selectedServiceClassification.name}</DropdownMenuToggler>
      {serviceClassifications.map(({ id, name }) => (
        <DropdownMenuItem key={id} onClick={() => onChange(id)} selected={selectedServiceClassificationId === id}>
          {name}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

ServiceClassification.propTypes = {
  selectedServiceClassificationId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
